let qualityForm = () => {

    let module = {},
        button1,
        button2,
        buttonQuizForm,
        buttonBack,

        attachEvents = () => {


             buttonQuizForm.on('click', (e) => {
                if(! $('#quiz-form')[0].checkValidity()) {
                    e.preventDefault();
                    let valid = true;

                    $('#quiz-form input, #quiz-form select').each(() => {

                        if (! this.checkValidity()) {
                            $(this).siblings('.invalid-feedback').slideDown();
                            $(this).parent().siblings('.invalid-feedback').slideDown();
                            valid = false
                        } else {
                            $(this).siblings('.invalid-feedback').slideUp();
                            $(this).parent().siblings('.invalid-feedback').slideUp();
                        }
                    });

                    if (valid) {
                        $(this).trigger('click');
                    }
                }

            });

            button1.on('click', (e) => {

                if(! $('#quality-form-1')[0].checkValidity()) {
                    $('#quality-form-step-1 input, #quality-form-step-1 select').each(function () {

                        if (! this.checkValidity()) {
                            $(this).siblings('.invalid-feedback').slideDown();
                            $(this).parent().siblings('.invalid-feedback').slideDown();
                        } else {
                            $(this).siblings('.invalid-feedback').slideUp();
                            $(this).parent().siblings('.invalid-feedback').slideUp();
                        }
                    });

                    e.preventDefault();
                } else {
                    e.preventDefault();
                    ga('send', 'event', 'visit-start', 'click', 'webpage');

                    // Let's store data in javascript so we can display it in the last step
                    $('#quality-form-step-1').hide();
                    $('#quality-form-step-1 + div').hide();

                    $('.form-steps-list li:nth-child(1)').removeClass('active').addClass('finished');
                    $('.form-steps-list li:nth-child(2)').removeClass('circle').addClass('circleless');

                    $('.form-steps-list li:nth-child(3)').addClass('active');

                    $('#quality-form-step-2').show();
                    $('#quality-form-step-2-submit').show();

                    $('#name').attr("required", true);
                    $('#email').attr("required", true);
                    $('#phone').attr("required", true);
                    $('#quality-check').attr("required", true);

                    let _scrollOffset = 96;
                    if ($(window).width() < 992) {
                        _scrollOffset = 64;
                    }


                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('#quality-form-2').offset().top - _scrollOffset
                    }, 1000);
                }

            });

            button2.on('click', (e) => {

                if(! $('#quality-form-2')[0].checkValidity()) {
                    $('#quality-form-step-2 input').each(function () {

                        if (! this.checkValidity()) {
                            $(this).parent().addClass('has-errors');

                            $(this).siblings('.invalid-feedback').slideDown();
                            $(this).parent().siblings('.invalid-feedback').slideDown();
                        } else {
                            $(this).parent().removeClass('has-errors');

                            $(this).siblings('.invalid-feedback').slideUp();
                            $(this).parent().siblings('.invalid-feedback').slideUp();
                        }
                    });

                    e.preventDefault();
                } else {
                    e.preventDefault();
                    ga('send', 'event', 'visit-finish', 'click', 'webpage');
                    // Set date based on location
                    // If the #date exists, use this for date, else get location index
                    let date = ';'
                    if ($('.quality-form #date').length) {
                        date = $('.quality-form #date').val();
                    } else {
                        let _id = $('.quality-form #location option:selected').data('id');
                        date = $('.quality-form .picker_item_' + _id).val();
                    }

                    jQuery.post(
                        ajaxurl,
                        {
                            'action': 'visitor_form',
                            'location':   $('.quality-form #location').val(),
                            'date':       date,
                            'people':     $('.quality-form #number').val(),
                            'first':      $('.quality-form #first').val(),
                            'last':       $('.quality-form #last').val(),
                            'email':      $('.quality-form #email').val(),
                            'country_code':$('.quality-form #country_code').val(),
                            'phone':      $('.quality-form #phone').val(),
                            'terms':      $('.quality-form #quality-check').val(),
                            'nonce':      $('.quality-form #nonce').val(),
                            'recaptcha_response':   $('.quality-form .recaptchaResponse').val()
                        },
                        function(response) {
                            $('#quality-form-step-2').hide();
                            $('#quality-form-step-2-submit').hide();

                            $('.form-steps-list li:nth-child(3)').removeClass('active').addClass('finished');
                            $('.form-steps-list li:nth-child(4)').removeClass('circle').addClass('circleless');
                            $('.form-steps-list li:nth-child(5)').addClass('active');

                            // Load data in confirmation
                            $('#confirmation_date').text(date);
                            $('#confirmation_number').text($('.quality-form #number').val());
                            $('#confirmation_location').text($('.quality-form #location').val());
                            $('#confirmation_name').text($('.quality-form #first').val() + ' ' + $('.quality-form #last').val());
                            $('#confirmation_email').text($('.quality-form #email').val());
                            $('#confirmation_phone').text($('.quality-form #country_code').val() + ' ' + $('.quality-form #phone').val());

                            $('#quality-form-step-confirmation').show();

                            $([document.documentElement, document.body]).animate({
                                scrollTop: $('#quality-form-step-confirmation').offset().top
                            }, 1000);
                        }
                    );

                }
            });

            buttonBack.on('click', (e) => {

                e.preventDefault();

                $('#quality-form-step-2').hide();
                $('#quality-form-step-2 + div').hide();

                $('.form-steps-list li:nth-child(1)').addClass('active').removeClass('finished');
                $('.form-steps-list li:nth-child(2)').addClass('circle').removeClass('circleless');

                $('.form-steps-list li:nth-child(3)').removeClass('active');

                $('#quality-form-step-1').show();
                $('#quality-form-step-1 + div').show();

                let _scrollOffset = 96;
                if ($(window).width() < 992) {
                    _scrollOffset = 64;
                }


                $([document.documentElement, document.body]).animate({
                    scrollTop: $('#quality-form-1').offset().top - _scrollOffset
                }, 1000);

            });

            // Swap select forms on location change
            $("#location").on("change", function() {
                let index = $(this).find(':selected').data('id');

                $(".picker_item").attr('style', 'display:none !important');
                $(".picker_item").removeAttr('required');

                $(".picker_item_" + index).attr('style','display:block !important');
                $(".picker_item_" + index).prop('required', true);
            });
        },

        init = () => {

            button1 = $('#go-to-quality-form-step-2')
            buttonBack = $('#go-to-quality-form-step-1')
            button2 = $('#go-to-quality-form-step-3')
            buttonQuizForm = $('#button-quiz-form')

            attachEvents();
        };

    module.init = init;

    return module;

};

export default qualityForm();